module.exports = __webpack_public_path__ + "static/img/image_solutions_professional_01.3af0124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_professional_01.png
// module id = cP11
// module chunks = 10